<template>
  <!-- 充值弹窗 -->
  <el-dialog title=""
    :visible.sync="visible"
    class="delete-card-dialog-components"
    :before-close="close"
    width="432px">
      <div class="content">
        <div class="content-title">
          <img src="../../assets/img/dialog/mine_pay_yinhangka.png" />删除银行卡
        </div>
        <div class="content-body">
          您是否确认删除本张银行卡？
        </div>

      </div>
      <div slot="footer" class="dialog-footer_one">
          <div @click="close" class="back">取消</div>
          <div @click="commit" class="commit">确认</div>
      </div>
  </el-dialog>

</template>

<script>
  import {bankList} from "@/util/config"
  import { mapState, mapMutations } from "vuex"
  // console.log("bankList: ",bankList);
  import { post } from "../../util/http";
  export default{
    computed: {
      ...mapState([
        "userInfo",
        "appConfig"
      ])
    },

    data(){
      return {
        visible : false,
        id : ""
      }
    },
    created(){
      this.cards = bankList;
      // console.log("this.userInfo",this.userInfo);
    },
    methods: {
      open(id){
        this.visible = true;
        this.id = id || 0;
      },
      close(){
        this.visible = false;
      },
      check(){
        let can = true;
        return can;
      },
      commit(){
        if(!this.id){
          return;
        }
        post({
          url: "/api/user/delBank/"+this.id,
        }).then(({ data: { data,status=0 } })  => {
          this.close();
          if(status==0){
            this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success'
            });
            this.$emit("refresh");
          }else{
            this.$message({
              showClose: true,
              message: '删除失败',
              type: 'warning'
            });
          }

        })
        .catch(err=>{
          console.log(err);
        })
      }
    }
  }
</script>

<style  scoped lang="stylus">
  .delete-card-dialog-components{
    z-index:1;
    border-radius: 8px;
    /deep/{
      .el-dialog__header{
        padding-top : 0px;
      }
      .el-dialog__headerbtn .el-dialog__close{
        color : #999999;
        font-size : 24px;
      }
      .el-input--suffix .el-input__inner{
        background: #F7F7F7;
      }
      .el-input__inner{
        border-color : #f0f0f0 !important;
        //color : #333333 !important;
        &:hover{
          border-color : #f0f0f0 !important;
        }
      }
      .el-select .el-input.is-focus .el-input__inner{
        border-color : #f0f0f0;
      }
      .el-select .el-input__inner:focus{
        border-color : #f0f0f0;
      }
      .el-range-input {
        background: #f7f7f7 !important;
        //color: #333333 !important;
      }
      .el-date-editor {
        border-color : #f0f0f0 !important;
        background: #f7f7f7 !important;
      }
      .el-date-table td.start-date span, .el-date-table td.end-date span{
        // background-color : #26D99D !important;
      }
      .el-input__inner{
        background: #f7f7f7 !important;
        border-color : #f0f0f0;
        //color : #333333;
      }
      .el-input__inner:focus{
        border-color : #f0f0f0;
      }
      .el-select-dropdown__item{
        text-align : center;
      }
      .el-select-dropdown__item.selected,.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
        background-color : rgba(38,217,157,0.10);
        color: #333333;
      }
    }
    .el-row{
      padding : 10px 0px;
    }
    .content{
      padding : 30px;
      font-size : 14px;
      .content-title {
        font-size: 18px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 550;
        padding-bottom : 30px;
        display: flex;
        align-items : center;
        img{
          width : 24px;
          height : 24px;
        }
      }
      .label{
        height : 36px;
        line-height : 36px;
      }
      .send-btn{
        color : #ffffff;
        background: #DCB273;
        border-radius: 16px;
        position : absolute;
        padding : 5px 10px;
        right : 10px;
        top : 50%;
        transform : translateY(-50%);
        cursor : pointer;
      }
    }

    .dialog-footer_one{
      padding : 0px 30px;
      &>div{
        margin:10px;
      }
      div.commit{
        height: 40px;
        background: #26D99D;
        border-radius: 20px;
      }
      div.back{
        height: 40px;
        color: #666666;
        background: #F7F7F7;
        border-radius: 20px;
      }
    }

  }
</style>
